import { HEADER_HEIGHT, MediaQuery, Theme } from '@pelando/components';
import styled from 'styled-components';

export const CommentsWrapper = styled.div`
  grid-area: comments;
  height: auto;
  min-height: 500px;
  box-shadow: 0 2px 8px -8px rgba(0, 0, 0, 0.5);
  background-color: rgb(${Theme.colors.Kilo});
  box-sizing: border-box;
  scroll-margin-top: calc(${HEADER_HEIGHT}px + 16px);
  padding-top: 8px;

  @media ${MediaQuery.SCREEN_LG_UP} {
    display: none;
  }
`;
